import { applyVariantFilter as applyVariantFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    mode?: any
}

export async function  applyVariantFilter ({
    mode,
    eventEmitter,
}: Props) {
    await applyVariantFilterDiagram({
        mode: mode.mode
     });
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()    
    eventEmitter.emit(Event.updateGaugeMetrics);

};


